export default {
    header: {
        logout: '로그아웃',
        profile: '개인정보',
        hotline: '핫라인',
        language: '언어'
    },
    footer: {},
    menu: {
        // 메뉴 재구성 2026-07: 섹션(구역 제목) + 병합 그룹
        sectionCommunication: '커뮤니케이션',
        sectionEducation: '학생 & 교육',
        sectionServices: '서비스',
        sectionFinance: '재무',
        sectionOperations: '운영',
        sectionSystem: '시스템',
        groupMyWork: '내 업무',
        groupUserPermission: '사용자 & 권한',
        groupSchoolData: '학교 & 데이터',
        groupNotificationNews: '알림 & 뉴스',
        groupStudentParent: '학생 & 학부모',
        groupTeaching: '수업 & 시간표',
        groupClb: '클럽',
        groupOtherServices: '기타 서비스',
        groupMeal: '급식',
        groupTuition: '학비 & 수납',
        groupHrTimekeeping: '인사 & 근태',
        groupStaff: '인사',
        groupTimekeeping: '근태',
        groupInventoryPurchase: '창고 & 구매',
        notification: '알림',
        news: '뉴스',
        email: '이메일',
        admissions: '입학 관리',
        bus: '스쿨버스',
        latePickup: '늦은 하원',
        nutrition: '영양',
        medical: '보건',
        payment: '결제',
        assets: '자산',
        guest: '손님',
        profile: '개인정보',
        listBrandname: '브랜드명 목록',
        listPhoneNumber: '전화번호 목록',
        listRequest: '요청 목록',
        createRequest: '요청 생성',
        logout: '로그아웃',
        // Dashboard
        dashboard: '대시보드',
        // Account Management
        accountManagement: '계정 관리',
        // Notification
        notificationManagement: '알림 관리',
        // News
        newsManagement: '뉴스 관리',
        // Attendance
        attendance: '출석',
        dailyAttendance: '일일 출석',
        leaveRequest: '학생 휴가 신청',
        mealAttendance: '식사 출석',
        latePickupAttendance: '지각 픽업 출석',
        clbAttendance: '동아리 출석',
        attendanceReport: '출석 보고서',
        clbAttendanceReport: '동아리 출석 보고서',
        mealReport: '식사 보고서',
        // Meal Management
        mealManagement: '식사 관리',
        mealService: '식사 서비스 관리',
        mealRegister: '식사 등록',
        // Parent Management
        parentManagement: '학부모 관리',
        parentList: '학부모 목록',
        parentLink: '학부모 연결',
        // SMS/Gmail
        smsManagement: 'SMS/Gmail 메시지',
        sendExternalSms: '외부 SMS 관리',
        sendAdvertisingEmail: '광고 이메일 관리',
        // Admissions
        admissionsManagement: '입학 관리',
        statusNameManagement: '상태명 관리',
        customerGroupManagement: '고객 그룹 관리',
        enrollmentCampaign: '모집 캠페인',
        customerList: '고객 목록',
        careToday: '오늘의 관리',
        admissionsReport: '보고서',
        // Timekeeping Config
        timekeepingConfig: '근태 설정',
        config: '설정',
        workShift: '근무 교대',
        teachingAssignment: '수업 배정',
        supplementaryWork: '추가 업무 관리',
        eventAssignment: '행사 배정',
        attendanceZone: '출석 구역 관리',
        attendanceWifi: '출석 WiFi 관리',
        timekeepingDevice: '근태 단말기 관리',
        // Timekeeping
        timekeeping: '근태 관리',
        leaveApplication: '휴가 신청',
        swapLesson: '수업 교환 요청',
        timekeepingList: '근태 관리',
        complaintApproval: '불만 승인',
        staffTimekeepingView: '직원 근태 조회',
        staffLessonView: '직원 수업 조회',
        timekeepingReport: '근태 보고서',
        lessonReport: '수업 보고서',
        lessonComplaint: '수업 불만 관리',
        // System
        system: '시스템',
        schoolGroupManagement: '학교 그룹 관리',
        schoolManagement: '학교 관리',
        dataDeclaration: '데이터 선언',
        schedule: '시간표',
        dataTransfer: '데이터 전송',
        permissionManagement: '권한 관리',
        permissionGroupManagement: '권한 그룹 관리',
        userGroupPermission: '사용자 그룹 권한',
        userManagement: '사용자 관리',
        versionManagement: '버전 관리',
        // Student
        studentManagement: '학생 관리',
        admissionsDiscount: '입학 할인',
        studentProfile: '학생 프로필',
        firstYearClassAssignment: '1학년 반 배정',
        gradeManagement: '성적 관리',
        finalGradeReport: '최종 성적 보고서',
        // Staff
        staffManagement: '직원 관리',
        staffList: '직원 관리',
        officerDocumentType: '직원 서류 목록',
        officerReport: '인사 보고서',
        // Fee
        feeManagement: '요금 관리',
        feeItems: '요금 항목',
        feeItemCollection: '요금 수납 관리',
        tuitionConfig: '학비 설정',
        tuitionReport: '학비 수납 보고서',
        feeCollectionReport: '요금 수납 보고서',
        receiptManagement: '영수증 관리',
        // Bus
        busManagement: '버스 관리',
        busServiceType: '버스 서비스 유형',
        busRoute: '버스 노선',
        busRegister: '버스 등록',
        busRegisterRequest: '버스 등록 요청',
        busAttendanceReport: '버스 출석 보고서',
        // CLB
        clbManagement: '동아리 관리',
        clbClass: '동아리 반 관리',
        clbRegister: '동아리 등록 관리',
        // Summer
        summerManagement: '여름 과정 관리',
        summerClass: '여름 반 관리',
        summerRegister: '여름 등록 관리',
        // Other Services
        otherServiceManagement: '기타 서비스 관리',
        productManagement: '제품 관리',
        serviceManagement: '서비스 관리',
        serviceRegister: '서비스 등록 관리',
        serviceApproval: '서비스 등록/취소 요청 승인',
        // Late Pickup
        latePickupManagement: '지각 픽업 관리',
        latePickupConfig: '지각 픽업 가격 설정',
        latePickupRegister: '지각 픽업 등록',
        latePickupReport: '지각 픽업 보고서',
        // Nutrition
        nutritionManagement: '영양 관리',
        foodType: '음식 유형',
        foodGroup: '음식 그룹',
        supplier: '공급업체',
        food: '식품',
        dish: '요리',
        menuManagement: '메뉴',
        weeklyMenu: '주간 메뉴',
        dailyMenu: '일일 메뉴',
        // Medical
        medicalManagement: '의료 관리',
        medicationManagement: '투약 관리',
        // Log
        logManagement: '로그 관리'
    },
    common: {
        search: '검색',
        add: '추가',
        edit: '수정',
        delete: '삭제',
        save: '저장',
        cancel: '취소',
        confirm: '확인',
        close: '닫기',
        back: '뒤로',
        next: '다음',
        previous: '이전',
        submit: '제출',
        reset: '초기화',
        export: '내보내기',
        import: '가져오기',
        print: '인쇄',
        view: '보기',
        detail: '상세',
        status: '상태',
        action: '작업',
        all: '전체',
        active: '활성',
        inactive: '비활성',
        yes: '예',
        no: '아니오',
        loading: '로딩 중...',
        noData: '데이터 없음',
        success: '성공',
        error: '오류',
        warning: '경고',
        info: '정보',
        total: '합계',
        page: '페이지',
        rowsPerPage: '페이지당 행 수',
        of: '/',
        home: '홈',
        selectAll: '전체 선택',
        deselectAll: '전체 선택 해제',
        required: '필수',
        optional: '선택',
        from: '부터',
        to: '까지',
        date: '날짜',
        time: '시간',
        startDate: '시작일',
        endDate: '종료일',
        createdAt: '생성일',
        updatedAt: '수정일',
        createdBy: '생성자',
        updatedBy: '수정자',
        name: '이름',
        code: '코드',
        description: '설명',
        note: '메모',
        phone: '전화번호',
        email: '이메일',
        address: '주소',
        gender: '성별',
        male: '남성',
        female: '여성',
        birthday: '생년월일',
        year: '년',
        month: '월',
        week: '주',
        day: '일',
        schoolYear: '학년도',
        semester: '학기',
        class: '반',
        grade: '학년',
        student: '학생',
        teacher: '교사',
        parent: '학부모',
        staff: '직원',
        school: '학교',
        department: '부서',
        position: '직위',
        subject: '과목',
        confirmDelete: '정말 삭제하시겠습니까?',
        confirmAction: '이 작업을 수행하시겠습니까?',
        deleteSuccess: '삭제 성공',
        saveSuccess: '저장 성공',
        updateSuccess: '업데이트 성공',
        createSuccess: '생성 성공',
        operationFailed: '작업 실패',
        networkError: '네트워크 연결 오류',
        sessionExpired: '세션 만료',
        permissionDenied: '권한 거부',
        invalidData: '잘못된 데이터',
        fileNotFound: '파일을 찾을 수 없음',
        uploadSuccess: '업로드 성공',
        downloadSuccess: '다운로드 성공',
        pleaseSelect: '선택해 주세요',
        pleaseEnter: '입력해 주세요',
        invalidFormat: '잘못된 형식',
        maxLength: '최대 길이',
        minLength: '최소 길이'
    },
    auth: {
        login: '로그인',
        logout: '로그아웃',
        username: '사용자명',
        password: '비밀번호',
        rememberMe: '로그인 유지',
        forgotPassword: '비밀번호 찾기',
        loginFailed: '사용자명 또는 비밀번호가 올바르지 않습니다!',
        loginSuccess: '로그인 성공',
        logoutSuccess: '로그아웃 성공',
        changePassword: '비밀번호 변경',
        currentPassword: '현재 비밀번호',
        newPassword: '새 비밀번호',
        confirmPassword: '비밀번호 확인'
    }
}
